<div>
  <sidenav-tree *ngFor="let treeElement of treeElements" [treeContent]="treeElement"></sidenav-tree>
</div>
